import axios from 'axios';
import store from './store';
import eventBus from './utils/eventBus';

const http = axios.create({
  baseURL: process.env.VUE_APP_BACKEND,
  headers: {
    'Content-Type': 'application/json',
    'X-JS-AJAX-Request': true,
  },
});

let isAlreadyFetchingAccessToken = false;
let tokenFetchError = false;
let subscribers = [];

function onAccessTokenFetched(accessToken) {
  subscribers = subscribers.filter((callback) => callback(accessToken));
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

http.interceptors.request.use((config) => {
  if (config.url.includes('uaa/oauth/token')) {
    tokenFetchError = false;
  }
  if (store.state.auth.accessToken !== null && config.url !== 'maintenance-mode-status') {
    config.headers.Authorization = `Bearer ${store.state.auth.accessToken}`; // eslint-disable-line no-param-reassign
  }
  let source = null;
  if (config.cancelToken && config.cancelToken.$cancel) {
    source = {
      token: config.cancelToken,
      cancel: config.cancelToken.$cancel,
    };
  } else {
    source = axios.CancelToken.source();
    config.cancelToken = source.token; // eslint-disable-line no-param-reassign
  }
  store.commit('requests/ADD_CANCEL_TOKEN', source);
  return config;
});

http.interceptors.response.use((response) => response, (error) => {
  const { config, response } = error;
  if (error.response && (error.response.headers['X-TS-BP-Action'] || error.response.headers['x-ts-bp-action'])) {
    window.location.href = error.response.data.url;
  } else if (error.response && error.response.status === 400) {
    if (error.response.data.error !== 'invalid_grant') {
      eventBus.$emit(
        'error400',
        error.response.data,
      );
    }
  } else if (error.response && (error.response.status !== 401) && (error.response.status !== 404)
    && (error.response.status !== 422)) {
    eventBus.$emit(
      'error500',
      error.response.data,
    );
  }
  if (response && response.status === 401 && !config.url.includes('uaa/oauth/token')) {
    if (!isAlreadyFetchingAccessToken && !tokenFetchError) {
      isAlreadyFetchingAccessToken = true;
      store.dispatch('auth/authPromise')
        .then((authResponse) => {
          tokenFetchError = false;
          isAlreadyFetchingAccessToken = false;
          onAccessTokenFetched(authResponse.data.access_token);
        })
        .catch(() => {
          tokenFetchError = true;
          isAlreadyFetchingAccessToken = false;
          onAccessTokenFetched(null);
          store.dispatch('auth/logout');
        });
    }
    if (tokenFetchError) {
      return Promise.reject(error);
    }
    return new Promise((resolve) => {
      addSubscriber((accessToken) => {
        if (accessToken === null) {
          return Promise.reject(error);
        }
        config.headers.Authorization = `Bearer ${accessToken}`; // eslint-disable-line no-param-reassign
        return resolve(http(config));
      });
    });
  }

  if (!error.response && !axios.isCancel(error)) {
    eventBus.$emit(
      'errorNetwork',
      {
        message: 'Selhalo připojení k serveru. Opakujte akci později',
      },
    );
  }

  return Promise.reject(error);
});

export default http;
